<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="page-administrator-list" class="ag-grid-container">
      <div class="vx-card">
        <grid-panel
            :column-defs="columnDefs"
            class="lg"
            :data="nodeData"
            :loading="loading"
            :search="searchQuery"
            :gridOptions="gridOptions"
            @rowClicked="rowClicked"
            @update:gridApi="(gridApi) => this.gridApi = gridApi"
            title="Commercial Product Nodes"
            autoSize
        >
          <vs-dropdown-item v-if="componentAccess.canCreate.access">
              <span
                  class="flex items-center"
                  @click="$router.push({ name: 'content-management.nodes.create' })"
              >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Create Node</span>
              </span>
            </vs-dropdown-item>
        </grid-panel>
      </div>
    </div>
</template>

<script>
  import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
  import vSelect from 'vue-select'
  import GridActionBar from "@/views/components/extra-components/GridActionBar";
  import CanAccessMixin from "@/components/mixins/CanAccessMixin";
  import CellRendererVerified from '@/views/components/ag-grid/cell-renderer/CellRendererVerified'
  import CellRendererDate from '@/views/components/ag-grid/cell-renderer/CellRendererDate'
  import { dateFilterParams } from '@/views/components/ag-grid/filter-params/DateComparator';
  import GridPanel from "@/views/components/ag-grid/GridPanel";
  
  export default {
    components: {
      vSelect,
      GridPanel,
      GridActionBar,
      CellRendererVerified,
      CellRendererDate,
    },
    mixins: [CanAccessMixin],
    data () {
      return {
        searchQuery: '',
        componentAccess: {
          canCreate: {
            route: 'content-management.news.create',
            access: false,
          },
          canEdit: {
            route: 'content-management.news.edit',
            access: false,
          },
        },
        loading: false,
        nodeData: [],
        disabledData: [],
  
        gridApi: null,
        gridOptions: {},
        columnDefs: [
          {
            headerName: 'ID',
            field: 'id',
            filter: 'agTextColumnFilter',
            minWidth: 200,
            width: 200,
            sort: 'asc',
            hide: true,
          },
          {
            headerName: 'Name',
            field: 'Name',
            filter: 'agTextColumnFilter',
            minWidth: 250,
          },
          {
            headerName: 'Description',
            field: 'Description',
            filter: 'agTextColumnFilter',
            minWidth: 250,
          },
          {
            headerName: 'Parent Node Name',
            field: 'parent_node.Name',
            filter: 'agTextColumnFilter',
            minWidth: 250,
          },
          {
            headerName: 'Localization Description',
            field: 'localization.LocalizationDescription',
            filter: 'agTextColumnFilter',
            minWidth: 128,
            maxWidth: 128,
          },
          {
            headerName: 'Path',
            field: 'Path',
            filter: 'agTextColumnFilter',
            minWidth: 128,
            maxWidth: 128,
          },
          {
            headerName: 'Image',
            field: 'Image',
            filter: 'agTextColumnFilter',
            minWidth: 128,
            maxWidth: 128,
          },
          {
            headerName: 'Tag',
            field: 'Tag',
            filter: 'agTextColumnFilter',
            minWidth: 128,
            maxWidth: 128,
          },
          {
            headerName: 'Level',
            field: 'Level',
            filter: 'agTextColumnFilter',
            minWidth: 128,
            maxWidth: 128,
          },
          {
            headerName: 'Deleted',
            field: 'IsDeleted',
            cellRenderer: 'CellRendererVerified',
            cellClass: 'text-center',
            minWidth: 128,
            maxWidth: 128,
          },
          {
            headerName: 'Enabled',
            field: 'IsEnabled',
            cellRenderer: 'CellRendererVerified',
            cellClass: 'text-center',
            minWidth: 128,
            maxWidth: 128,
          },
          {
            headerName: 'Organisation',
            field: 'Organization',
            filter: 'agTextColumnFilter',
            minWidth: 128,
            maxWidth: 128,
          },
        ],
      }
    },
    methods: {
      modalError(errorMessage) {
        this.$vs.notify({
          color: 'danger',
          title: 'Error occurred',
          text: errorMessage,
          position: 'top-right'
        })
      },
      success(successMessage) {
        this.$vs.notify({
          color: 'success',
          title: 'Contacts updated',
          text: successMessage,
          position: 'top-right'
        })
      },
      rowClicked(data) {
        if (!this.componentAccess.canEdit.access) {
          return;
        }

        this.$root.$router.push({ path: `/content-management/nodes/${data.data.id}` })
      },
      async list() {
        try {
          this.loading = true;

          const { data: responseData } = await this.$api.contentManagementNodes.list();
          this.nodeData = responseData.data;

          this.gridApi.paginationGoToFirstPage();
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      },
      loadList () {
        this.list();
      },
    },
    created () {
      this.loadList();
    },
  }
  </script>
  
  <style lang="scss">
  #page-administrator-list {
    .administrator-list-filters {
      .vs__actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-58%);
      }
    }
  }
  </style>
  